import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CastOperatorParameters} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"
import {GeometryCastOperatorNode, castOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"

export type CurveGeometryCastOperatorParameters = CastOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryCastOperatorParameters> = {
    nodeClass: "CurveGeometryCastOperator",
    validation: {
        parameters: castOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryCastOperator extends GeometryCastOperatorNode<1, CurveGeometryAttributeLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
